import { render, staticRenderFns } from "./view_video.vue?vue&type=template&id=394b7699&lang=pug"
import script from "./view_video.vue?vue&type=script&lang=js"
export * from "./view_video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394b7699')) {
      api.createRecord('394b7699', component.options)
    } else {
      api.reload('394b7699', component.options)
    }
    module.hot.accept("./view_video.vue?vue&type=template&id=394b7699&lang=pug", function () {
      api.rerender('394b7699', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/components/view_video.vue"
export default component.exports